import accountSummaryExplanationTemplate from 'views/modals/account-summary-explanation.html';

export class AccountSummaryExplanationComponent implements ng.IComponentOptions {
  public templateUrl: string;

  constructor() {
    this.templateUrl = accountSummaryExplanationTemplate;
  }
}
